import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/globalConfig';
import openActivity, { EVENT_LIST_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';

import { CHECK_IP_LOCATION } from '@store/ipCheck';

/**
 *  const language = {
        'en-US': ``,
        'es-ES': ``,
        'tr-TR': ``,
        'zh-CN': ``,
        'zh-TW': ``,
        'fr-FR': ``,
        'pt-PT': ``,
        'vi-VN': ``,
        'th-TH': ``,
        'ja-JP': ``,
        'ko-KR': ``,
        'ru-RU': ``,
        'de-DE': ``,
        'it-IT': ``,
        'pl-PL': ``,
        'ar-SA': ``,
        'id-ID': ``
      };
      return language[this.lang] || language['en-US'];
 */

export default {
  data() {
    return {
      // 1、加一个变量
      visibleRightsNotice: false,
      visibleCloseCouponSend: false,
      visiblePayPalNotice: false,
      visibleBzitNotice: false,
      visibleDownJpPayType: false,
      visibleBankPayDown: false,
      visibleMayiPayDown: false,
      visiblePnsPayDown: false,
      visibleMayiPayDownButton: false,
      visiblePnsPayDownButton: false,
      visibleKoDzgNotice: false,
      visiblePnsPayNoticeDown: false,
      visibleJpGamePayDown: false,
      visibleDzgJpExtraCoinDown: false,
      visibleMayiKoNotice: false,
      visibleMayiKoNoticeButton: false,
      visibleMayiPayChangeNotice: false,
      visibleJiangMeiExtraCoinDown: false,
      visibleKOneDownLimitActivityButton: false,
      visibleKOneDownLimitActivity: false,
      visibleKOneDownVip: false,
      visibleDzgJpCouponDown: false,
      visibleJiangmeiCouponDown: false,

      visibleJpPayDown: false, // 日本地区三方下架公告
      jpPayDownTitle: '日本の決済チャネル調整に関する重要なお知らせ',

      jpPayPalTitle: `支払い方法の調整に関するお知らせ`,
      jpPayPalContent: `プレイヤーの皆様:\n\n技術的な調整のため、2025年8月1日（金）12:00（UTC+9）より、PayPay決済チャネルを一時的に停止させていただきます。停止後も、他の決済方法でチャージを行うことができます。\n\nPayPayですでにチャージされたゲーム内アイテムは、引き続き通常通りご利用いただけます。8月1日以降も、チャージ済みの残高は、ゲーム内で全額使用可能です（アイテムやパックの購入など）。\n\n今回の調整により、お客様のゲームデータやアカウントの安全性に影響はございません。ご不便をおかけして誠に申し訳ございません。ご理解とご支援に重ねて感謝申し上げます。`,

      downJpPayTypeTitle: '支払い方法の調整に関するお知らせ',
      downJpPayTypeContent:
        'プレイヤーの皆様:\n\n技術的な調整のため、2025年8月22日（金）17:00（UTC+9）より、一部の決済チャネルを一時的に停止させていただきます。停止後も、他の決済方法でチャージを行うことができます。\n\n関連する決済チャネルですでにチャージされたゲーム内アイテムは、引き続き通常通りご利用いただけます。8月22日以降も、チャージ済みの残高は、ゲーム内で全額使用可能です（アイテムやパックの購入など）。\n\n今回の調整により、お客様のゲームデータやアカウントの安全性に影響はございません。ご不便をおかけして誠に申し訳ございません。ご理解とご支援に重ねて感謝申し上げます。',

      bankPayDownTitle: '付款方式調整公告',
      bankPayDownContent:
        '【付款方式調整公告】各位玩家：\n\n由於遭到不法份子攻擊及利用，為保護玩家的資產安全，自2025年8月22日（本週五）上午11:00起，我們將緊急暫停【銀行匯款】的支付方式。暫停後，您仍可透過其他付款方式進行儲值。\n\n透過【銀行匯款】已儲值的遊戲內物品，仍可繼續正常使用。8月22日之後，已儲值的餘額仍可在遊戲內全額使用（例如購買物品或禮包等）。\n\n本次調整不會影響您的遊戲資料或帳戶安全。對於由此給您帶來的不便，我們深感抱歉。感謝您的理解與支持。',

      mayiPayDownTitle: '日本における決済チャネル調整に関する重要なお知らせ',
      mayiPayDownContent:
        '親愛なる「統領」様:\n平素より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境をご提供するため、「2025年12月」頃に以下の決済システムの調整を予定しております:公式サイトのチャージプラットフォームのサービスを終了いたします。（具体的な日程は事前にお知らせいたします）\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\nサービス終了後は、以下の公式チャンネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n注意事項\n1. 公式ウェブサイトのチャージプラットフォームを正式に終了する前に、関連するチャージイベントのルールを段階的に調整させていただきます。\n2.公式サイトのチャージプラットフォームを通じて購入されたゲーム内通貨は、引き続き通常通りご利用いただけます。\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n「立ち上がれ、アリ帝国」運営チーム\n\n2025年8月28日',

      pnsPayDownTitle: '日本の決済チャネル調整に関する重要なお知らせ',
      pnsPayDownContent:
        '指揮官の皆様：\n日頃より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境を提供するため、2025年12月16日午後5時（日本標準時）より、決済システムを以下のように調整させていただきます：\n日本向けの公式ウェブサイトチャージプラットフォームおよびPC版の決済機能を終了いたします。\n\n一、変更内容\n第三者決済チャネルとの契約期間満了に伴い更新を行わないため、公式ウェブサイトチャージプラットフォームは予定通り終了いたします。\n以降、チャージは以下の公式チャネルのみでご利用いただけます：\nOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n二、関連特典の調整について\n日本向けの公式ウェブサイトチャージプラットフォーム終了に伴い、プレイヤーの皆様の特典が決済チャネルの調整の影響を受けないよう、日本向けの一部公式サイト特典キャンペーンを同時に調整いたします。この調整は日本の第三者決済チャネル終了後の代替案として、日本向けのみ適用されます。\nご注意：今回の特典キャンペーンの代替案は、日本向けの第三者決済チャネルの今後の契約更新状況により調整される可能性がございます。最新のお知らせにご注目ください。ご理解いただき、ありがとうございます。\n\n1. 特典センターの大幅アップグレード！\n特典センターのポイント規則は変更せず、獲得済みのポイントはチャージプラットフォーム終了後も消失しません。同時に、特典センターの交換アイテムが大幅にアップグレードされます！機密設計図、ソーラーパネル、超伝導量子材料など、高価値なゲームアイテムが新たに追加され、交換の選択肢がより豊富になりました。お気に入りのボーナスをチェックしてみてください！\n\n2. キャンペーン参加制限の全面解除！\nこれまで公式サイトチャージ限定だった専用キャンペーンが、全面的に開放されます！iOSやGoogle Playでチャージされた方も、ゲーム内のチャージ特典キャンペーン（チャージ累計ボーナス、季節限定セールなど）にご参加いただけます。特典センターでも、ゲーム内チャージで獲得したEXPが同時に計算されます。\n\n3. チャージ特典キャンペーン開催！\n皆様のチャージをより価値あるものにし、チャージチャネルの調整による特典の損失を避けるため、新たに「チャージ特典」キャンペーンを特別に開催いたします。これまでのクーポン特典と完全に一致しています！\n参加方法は以下の通りです：\n（1） 任務を受け取り、特典の旅を開始！\n特典センターで特典任務を選択してください。一度に1つの任務のみ受け取れ、任務の有効期間は7日間（受け取り後からカウント開始）です。\nご注意：必ず任務を受け取ってからチャージしてください。そうでないと進捗が累計されません！\n（2） チャージ累計で賞金プール、豪華ボーナスにアップグレード！\n任務受け取り後、ゲーム内でのチャージ金額がリアルタイムで賞金プールに累計されます。チャージが多いほど、賞金プールのボーナスがより豪華になります！\n任務完了後、任務に記載されたチャージ金額の一定割合で追加の金券ボーナスを獲得できます。最大1500金券を獲得可能で、これまでのクーポン上限と一致しています！\n（3） ボーナス受け取りで簡単入手！\n任務終了時、特典センターで賞金プール内のすべてのボーナスを受け取ることができます。\n金券は直接ゲーム内に配布され、ゲーム内の任意のパックの購入にいつでもご利用いただけます！\n\n三、注意事項\n1. 公式ウェブサイトのクーポン配布および使用は2025年12月16日午後5時（日本標準時）に同時に停止いたします。不要な損失を避けるため、必ずこの時間までにご使用ください。\n2. 公式ウェブサイトチャージプラットフォームを通じてチャージされたゲーム内通貨とアイテムは、引き続き通常通りご利用いただけます。\n3. 一部のチャージ方法（コンビニ決済、クレジットカードなど）で遅延が発生する可能性があります。2025年12月16日日本時間午後5時までにチャージが反映されない場合（つまり、チャージが確認できない場合）、そのチャージは自動的にキャンセルされます。チャージ時間にご注意ください。\n4. PC版プレイヤーは通常通りログインしてプレイできます。キャラクターデータはモバイル版とリアルタイムで同期されます。決済入口のみが閉鎖されます。\n\nこの変更はゲームデータやアカウントのセキュリティに影響を与えません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、誠にありがとうございます。\n「パズル&サバイバル」運営チーム\n2025年12月5日',
      koDzgNoticeContent:
        '친애하는 사장님, 안녕하세요. 기술적인 이유로 현재 블랑코 스토어 상품중 원보 상품은 모두 내리게 되었습니다. 원보 결제가 필요시 먼저 사장통보를 구입해 주시고 다시 게임에 돌아가 획득하신 사장통보로 원보를 다시 구입해 주시기를 바랍니다. 감사합니다. ',

      pnsNoticeDownTitle: '支払い方法の調整に関するお知らせ ',
      pnsNoticeDownContent:
        'プレイヤーの皆様: \n技術的な調整のため、2025年8月22日（金）17:00（UTC+9）より、一部の決済チャネルを一時的に停止させていただきます。停止後も、他の決済方法でチャージを行うことができます。 関連する決済チャネルですでにチャージされたゲーム内アイテムは、引き続き通常通りご利用いただけます。8月22日以降も、チャージ済みの残高は、ゲーム内で全額使用可能です（アイテムやパックの購入など）。 \n今回の調整により、お客様のゲームデータやアカウントの安全性に影響はございません。ご不便をおかけして誠に申し訳ございません。ご理解とご支援に重ねて感謝申し上げます。',

      // 日本大掌柜
      jpDownDaZhangGuiTitle:
        '日本における決済チャネル調整に関する重要なお知らせ',
      jpDownDaZhangGuiContent:
        '親愛なる主人様:\n平素より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境をご提供するため、「2025年12月」頃に以下の決済システムの調整を予定しております：ゲーム公式チャージセンターとブラウザゲームの決済機能はサービスを終了します。（具体的な日程は事前にお知らせいたします）\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\nサービス終了後は、以下の公式チャンネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n注意事項\n1. 調整期間中の主人様のゲーム体験を維持するため、「2025年9月8日」より、すべての公式サイトのチャージ関連イベント（『プレミアムセンター』を含みますが、これに限定されません）における従来の公式サイトでのチャージ任務が、アプリ内課金（App Store、Google Play）でも完了できるようになります。\n2.公式サイトのチャージプラットフォームを通じて購入されたゲーム内通貨は、引き続き通常通りご利用いただけます。\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n「商人放浪記」運営チーム\n2025年9月2日',

      // 日本大千
      jpDownDaQianTitle: '日本における決済チャネル調整に関する重要なお知らせ',
      jpDownDaQianContent:
        '親愛なるプレイヤー:\n平素より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境をご提供するため、「2025年12月」頃に以下の決済システムの調整を予定しております：公式サイトのチャージプラットフォームのサービスを終了いたします。（具体的な日程は事前にお知らせいたします）\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\nサービス終了後は、以下の公式チャンネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n注意事項\n1. 調整期間中のプレイヤーのゲーム体験を維持するため、「2025年9月8日」より、すべての公式サイトのチャージ関連イベント（『プレミアムセンター』を含みますが、これに限定されません）における従来の公式サイトでのチャージ任務が、アプリ内課金（App Store、Google Play）でも完了できるようになります。\n2.公式サイトのチャージプラットフォームを通じて購入されたゲーム内通貨は、引き続き通常通りご利用いただけます。\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n「妖遊記~トントン名人になれ」運営チーム\n2025年9月2日',

      // 日本江美
      jpDownJiangmeiTitle: '日本における決済チャネル調整に関する重要なお知らせ',
      jpDownJiangmeiContent:
        '親愛なる旦那様:\n平素より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境をご提供するため、「2025年12月」頃に以下の決済システムの調整を予定しております：ゲーム公式チャージセンターとブラウザゲームの決済機能はサービスを終了します。（具体的な日程は事前にお知らせいたします）\n\n変更内容\n\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\nサービス終了後は、以下の公式チャンネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n注意事項\n1. 調整期間中の旦那様のゲーム体験を維持するため、「2025年9月8日」より、すべての公式サイトのチャージ関連イベント（『プレミアムセンター』を含みますが、これに限定されません）における従来の公式サイトでのチャージ任務が、アプリ内課金（App Store、Google Play）でも完了できるようになります。\n2.公式サイトのチャージプラットフォームを通じて購入されたゲーム内通貨は、引き続き通常通りご利用いただけます。\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n「旦那様の一発逆転人生」運営チーム\n2025年9月2日',

      // 日本霸业
      jpDownBaYeTitle: '日本における決済チャネル調整に関する重要なお知らせ',
      jpDownBaYeContent:
        '親愛なる主公様:\n平素より格別のご愛顧を賜り、誠にありがとうございます。より安全な決済環境をご提供するため、「2025年12月」頃に以下の決済システムの調整を予定しております：ゲーム公式チャージセンターとブラウザゲームの決済機能はサービスを終了します。（具体的な日程は事前にお知らせいたします）\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\nサービス終了後は、以下の公式チャンネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n注意事項\n1. 調整期間中の主公様のゲーム体験を維持するため、「2025年9月8日」より、すべての公式サイトのチャージ関連イベント（『プレミアムセンター』を含みますが、これに限定されません）における従来の公式サイトでのチャージ任務が、アプリ内課金（App Store、Google Play）でも完了できるようになります。\n2.公式サイトのチャージプラットフォームを通じて購入されたゲーム内通貨は、引き続き通常通りご利用いただけます。\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n「爆速三国-フルスロットル」運営チーム\n2025年9月2日',

      // 日本大掌柜
      dzgjpExtraCoinDownTitle: ' ',
      dzgjpExtraCoinDownContent:
        '親愛なる主人様:\n\n公式サイトのチャージプラットフォームは「2025年9月29日 00:00（utc+9）」に還元機能を終了し、公式サイトでのチャージおよびウェブゲーム内での商品購入による追加元宝の還元は行われなくなります。\n\nこの調整に伴い、主人様のゲーム体験を確保するため、ゲーム内で同時に商人通宝を導入いたします。商人通宝の購入で50%の元宝還元が受けられます。還元サービスは以下の公式チャネルでご利用いただけます:\niOSユーザー: App Store（アプリ内課金）\nAndroidユーザー: Google Playストア（アプリ内課金）\n\n調整の背景：以前のお知らせ通り、第三者決済チャネルとの契約が満了し、更新中止に伴い、「2025年12月」に以下の支払いシステムの調整を予定しております：公式サイトのチャージプラットフォームおよびウェブゲームの決済機能のサービスを停止（具体的な日程は事前にお知らせいたします）\n\n今後、さらに多くのお得なイベントを実施し、主人様が様々な方法で高コストパフォーマンスの報酬を獲得できるよう努めてまいります。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n\n「商人放浪記」運営チーム\n2025年9月26日',

      // 蚂蚁：针对韩国地区
      mayiKoNoticeTitle: ' ',
      mayiKoNoticeContentV1: `[가격 조정] 공식 충전 플랫폼 내 상품 원화 가격 조정 안내\n\n안녕하세요, 지휘관님.\n환율 변동으로 인해 2025년 10월 26일부터 공식 충전 플랫폼의 모든 상품 가격이 조정될 예정입니다.\n\n■ 가격 조정\n이해를 돕기 위해 아래에 구체적인 상품 가격 조정 내용을 정리해 두었습니다.\n조정된 상품 가격은 다음 링크 문서의 C열에 표시된 금액을 참조해 주시기 바랍니다.\n공식 충전 플랫폼 가격 조정: \n<a href="javascript:;" target="_blank" data-href="https://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0">https://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0</a>\n\n■ 특별 페이백 이벤트\n그동안 보내주신 성원에 보답하기 위해 한 달간 '특별 페이백 이벤트'(2025년 10월 26일 12:00 ~ 11월 26일 12:00 (KST))를 진행합니다. 이벤트 기간 동안 공식 충전 플랫폼에서 원화로 상품을 구매하시면(할인 쿠폰 방식 제외) 아래 표의 D열에 명시된 해당 금액의 할인 쿠폰을 페이백으로 받으실 수 있습니다.\n이벤트 기간 중 공식 충전 플랫폼에서 상품 구매 시 받을 수 있는 해당 금액의 할인 쿠폰 페이백: \n<a href="javascript:;" target="_blank" data-href="https://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0">https://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0</a>\n\n■ 주의 사항\n가격 조정은 단계적으로 시행되므로 게임 내 가격 표시에 지연이 있을 수 있습니다. 구매 시 인앱 \n구매 화면에 실제로 표시되는 가격을 반드시 다시 한 번 확인해 주시기 바랍니다.\n정책 변경 사항이 있을 경우 최대한 빨리 자세한 정보를 제공해 드리겠습니다. 이로 인해 불편을 끼쳐 드려 진심으로 죄송합니다. 여러분의 이해와 성원에 깊이 감사드립니다.`,
      mayiKoNoticeContentV35: `[가격 조정] 공식 충전 플랫폼 내 상품 원화 가격 조정 안내\n\n안녕하세요, 지휘관님.\n환율 변동으로 인해 2025년 10월 26일부터 공식 충전 플랫폼의 모든 상품 가격이 조정될 예정입니다.\n\n■ 가격 조정\n이해를 돕기 위해 아래에 구체적인 상품 가격 조정 내용을 정리해 두었습니다.\n조정된 상품 가격은 다음 링크 문서의 C열에 표시된 금액을 참조해 주시기 바랍니다.\n공식 충전 플랫폼 가격 조정: \nhttps://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0\n\n■ 특별 페이백 이벤트\n그동안 보내주신 성원에 보답하기 위해 한 달간 '특별 페이백 이벤트'(2025년 10월 26일 12:00 ~ 11월 26일 12:00 (KST))를 진행합니다. 이벤트 기간 동안 공식 충전 플랫폼에서 원화로 상품을 구매하시면(할인 쿠폰 방식 제외) 아래 표의 D열에 명시된 해당 금액의 할인 쿠폰을 페이백으로 받으실 수 있습니다.\n이벤트 기간 중 공식 충전 플랫폼에서 상품 구매 시 받을 수 있는 해당 금액의 할인 쿠폰 페이백: \nhttps://docs.google.com/spreadsheets/d/1rK4Q0e0hIgjgSZ4mJb5r9xhCwdgV0NZcJBfyKroBFdA/edit?gid=0#gid=0\n\n■ 주의 사항\n가격 조정은 단계적으로 시행되므로 게임 내 가격 표시에 지연이 있을 수 있습니다. 구매 시 인앱 \n구매 화면에 실제로 표시되는 가격을 반드시 다시 한 번 확인해 주시기 바랍니다.\n정책 변경 사항이 있을 경우 최대한 빨리 자세한 정보를 제공해 드리겠습니다. 이로 인해 불편을 끼쳐 드려 진심으로 죄송합니다. 여러분의 이해와 성원에 깊이 감사드립니다.`,

      // 蚂蚁：针对日本
      mayiPayChangeTitle:
        '公式サイトのチャージプラットフォームおよびプレミアムセンターのルール変更に関する重要なお知らせ',
      mayiPayChangeContent:
        '「統領」様へ\n\n 日頃より格別のご愛顧を賜り、誠にありがとうございます。公式サイトのチャージプラットフォームを正式に終了する前に、関連するチャージイベントのルールを段階的に調整させていただきます。\n\n公式サイトのチャージプラットフォームにおける10%ダイヤ還元は、「2025年10月9日」をもって終了する予定です。\n\nまた、プレミアムセンターシステムのバックエンドアップグレードに伴い、\n\n「2025年10月9日」にプレミアムセンターにおいて以下の変更を予定しております：\n\nプレミアムセンターのポイント規則を変更し、「アプリ内課金によるチャージ」のみポイントが獲得できるようになります。\n\n*アプリ内課金チャージ:\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n公式サイトのチャージプラットフォームを通じて獲得したポイントは、引き続き通常通りご利用いただけます。\n\nご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援をいただき、ありがとうございます！\n\n「立ち上がれ、アリ帝国」運営チーム\n2025/9/29',

      // 日本江美加码下架
      jpJiangMeiExtraCoinDownTitle: '',
      jpJiangMeiExtraCoinDownContent:
        '親愛なる旦那様:\n\n公式サイトのチャージプラットフォームは「2025年10月16日16:00（utc+9）」に還元機能を終了し、公式サイトでのチャージおよびウェブゲーム内での商品購入による追加元宝の還元は行われなくなります。\n\nこの調整に伴い、旦那様のゲーム体験を確保するため、ゲーム内にて金銖購入ボーナスキャンペーンを同時開催いたします、金銖の購入で10%の元宝還元が受けられます。還元サービスは以下の公式チャネルでご利用いただけます:\n\niOSユーザー: App Store（アプリ内課金）\nAndroidユーザー: Google Playストア（アプリ内課金）\n\n背景説明：以前のお知らせ通り、第三者決済チャネルとの契約が満了し、更新中止に伴い、「2025年12月」に以下の支払いシステムの調整を予定しております：公式サイトのチャージプラットフォームおよびウェブゲームの決済機能のサービスを停止（具体的な日程は事前にお知らせいたします）\n\n今後、さらに多くのお得なイベントを実施し、旦那様が様々な方法で高コストパフォーマンスの報酬を獲得できるよう努めてまいります。\nご理解とご支援を賜り、重ねて御礼申し上げます。\n\n「旦那様の一発逆転人生」運営チーム\n2025年10月13日',

      dzgjpCouponDownTitle: ' ',
      dzgjpCouponDownContent:
        '親愛なるご主人様:\n\nプレミアムセンターの優待券配布戦略の評価に基づき、以下の調整を行うことになりました:\n\n2025年11月6日17:00 (utc+9) より、優待券の配布を停止いたします。\n\nなお、2025年11月6日17:00 (utc+9) 以前に受け取られた優待券は、その有効期限まで引き続きご利用いただけます。\n\nまた、プレミアムセンターのチャージ任務は、以下の公式チャンネルでのみ参加可能となります:\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\nこの度の変更によりご不便をおかけし、誠に申し訳ございません。ご主人様の変わらぬご支援とご理解に心より感謝申し上げます。',

      jpJiangmeiCouponDownTitle: '',
      jpJiangmeiCouponDownContent:
        '尊敬するプレイヤーの皆様：\n\nプレミアムセンターの優待券配布戦略の評価に基づき、以下の調整を行うことになりました:\n\n2025年11月6日17:00 (utc+9) より、優待券の配布を停止いたします。\n\nそのため、ポイントショップで交換可能なアイテムの種類を増やし、より良い交換体験を提供できるよう努めてまいります。\n\nなお、2025年11月6日17:00 (utc+9) 以前に受け取られた優待券は、その有効期限まで引き続きご利用いただけます。\n\nさらに、2025年11月6日17:00 (utc+9) より、チャージイベントに以下の調整を行います：\n1.プレミアムセンターのチャージミッションは、アプリ内課金（App StoreおよびGoogle Playストア経由）でのみ参加可能となります。\n2.現行の公式イベント「合計チャージ額で報酬GET」は終了し、ゲーム内に新たなイベントが登場します。毎日指定の金額をアプリ内でチャージすることで、豪華なゲームアイテムを受け取ることができます。\n\n今回の調整によりご不便をおかけすることを深くお詫び申し上げます。プレイヤーの皆様の変わらぬご支援とご理解に心より感謝申し上げます。'
    };
  },
  computed: {
    ...mapGetters(['gameId', 'gameInfoConfig']),
    ...mapState({
      lang: state => state.lang
    }),
    // 2、加title和content
    pnsRightCenterNoticeTitle() {
      const language = {
        'en-US':
          'Privilege Center Coupon Redemption & VIP Coupon Retirement Notice',
        'es-ES':
          'Aviso de canje de cupones del Centro de Privilegios y retiro de cupones VIP',
        'tr-TR':
          'Ayrıcalık Merkezi Kupon Kullanımı ve VIP Kupon Emeklilik Duyurusu',
        'zh-CN': '关于【权益中心】优惠券兑换以及VIP优惠券下架提醒',
        'zh-TW': '關於【權益中心】優惠券兌換以及VIP優惠券下架提醒',
        'fr-FR':
          'Centre de Privilèges : Échange de coupons et Retrait des coupons VIP',
        'pt-PT':
          'Centro de Privilégios - Aviso de Resgate de Cupom e Expiração de Cupom VIP',
        'vi-VN':
          'Về việc đổi phiếu ưu đãi [Trung tâm quyền lợi] và thông báo ngừng phát hành phiếu ưu đãi VIP',
        'th-TH':
          'แจ้งเตือนการแลกคูปองใน [ศูนย์สิทธิประโยชน์] และการยุติการแจกคูปอง VIP',
        'ja-JP':
          '【プレミアムセンター】のクーポン交換およびVIPクーポン終了のお知らせ',
        'ko-KR': '[프리미엄 센터] 쿠폰 교환 및 VIP 쿠폰 중단 안내',
        'ru-RU':
          'Применение купонов центра привилегий и прекращение действия VIP-купонов',
        'de-DE':
          'Hinweis zur Coupon-Einlösung im Privilegzentrum & Auslaufen der VIP-Coupons',
        'it-IT': 'Avviso Centro Privilegi: Riscatto Coupon e Ritiro Coupon VIP',
        'pl-PL':
          'Centrum Przywilejów: Wymiana Kuponów i Informacja o Wycofaniu Kuponów VIP',
        'ar-SA': 'بشأن [مركز الفوائد] تبادل القسائم وتذكير بإيقاف قسائم VIP',
        'id-ID':
          'Tentang penukaran kupon [Pusat Benefit] dan pengumuman penghapusan kupon VIP'
      };
      return language[this.lang] || language['en-US'];
    },
    pnsRightCenterNotice() {
      const language = {
        'en-US':
          'Greetings, Commander!\n\nThank you for your continued support! The new Privilege Center is now live. The original VIP Points Event coupons will no longer be distributed after 10:00 (UTC) on July 25, 2025. Please head to the new Privilege Center to redeem your VIP coupons.\n\nNote: The automatic coupon redemption feature must be manually enabled. To do so, go to: Privilege Center Homepage > Member Benefits > Enable Auto Redeem Coupons > Select Coupons to Auto-Redeem > Confirm.',
        'es-ES':
          '¡Hola, comandante!\n\n¡Gracias por tu continuo apoyo! El nuevo Centro de privilegios ya está en funcionamiento. Los cupones originales del evento de Puntos VIP dejarán de distribuirse después de las 10:00 (UTC) del 25 de julio de 2025. Por favor, dirígete al nuevo Centro de privilegios para canjear tus cupones VIP.\n\nNota: La función de canje automático de cupones debe activarse manualmente. Para hacerlo, ve a: Página principal del Centro de privilegios > Beneficios de miembros > Activar Canjear cupones automáticamente > Seleccionar cupones para el canje automático > Confirmar.',
        'tr-TR': `Selamlar Kumandan!\n\nSürekli desteğiniz için teşekkürler! Yeni Ayrıcalık Merkezi artık aktif. Orijinal VIP Puanları Etkinliği kuponları 25 Temmuz 2025 10.00'dan (UTC) sonra dağıtılmayacak. VIP kuponlarınızı kullanmak için lütfen yeni Ayrıcalık Merkezi'ne gidin.\n\nNot: Otomatik kupon kullanma özelliği manuel olarak etkinleştirilmelidir. Bunu yapmak için şu adrese gidin: Ayrıcalık Merkezi Ana Sayfası > Üye Avantajları > Kuponları Otomatik Kullan Etkinleştir > Otomatik Kullanılacak Kuponları Seç > Onayla.`,
        'zh-CN':
          '尊敬的指挥官：\n\n感谢您一直以来的支持！「权益中心」系统已全新上线，原「VIP积分活动」优惠券将于2025年7月25日10点（UTC）停止发放，请前往全新「权益中心」系统兑换VIP优惠券。\n\n请注意：自动发放优惠券功能需手动开启，开启路径：权益中心首页-查看会员权益-优惠券自动发放-点击开启-选择需要自动兑换的优惠券-确认开启',
        'zh-TW':
          '尊敬的指揮官：\n\n感謝您一直以來的支持！「權益中心」系統已全新上線，原「VIP積分活動」優惠券將於2025年7月25日10點（UTC）停止發放，請前往全新「權益中心」系統兌換VIP優惠券。\n\n請注意：自動發放優惠券功能需手動開啟，開啟路徑：權益中心首頁-查看會員權益-優惠券自動發放-點擊開啟-選擇需要自動兌換的優惠券-確認開啟',
        'fr-FR': `Salutations, Commandant !\n\nMerci de votre fidélité ! Le nouveau Centre de Privilèges est désormais disponible. Les coupons de l'événement Points VIP ne seront plus distribués après le 25/07/2025 à 10h00 (UTC). Veuillez vous rendre au nouveau Centre de Privilèges pour échanger vos coupons VIP.Remarque : la fonction d'échange automatique des coupons doit être activée manuellement. Pour ce faire, rendez-vous sur : Page d'accueil du Centre de privilèges > Avantages membres > Activer l'échange automatique des coupons > Sélectionner les coupons à échanger automatiquement > Confirmer.`,
        'pt-PT':
          'Saudações, Comandante!\n\nObrigado por seu apoio contínuo! O novo Centro de Privilégios já está disponível. Os cupons originais do Evento de Pontos VIP não serão mais distribuídos após as 10:00 (UTC) de 25 de julho de 2025. Por favor, dirija-se ao novo Centro de Privilégios para resgatar seus cupons VIP.\n\nNota: O recurso de resgate automático de cupons deve ser ativado manualmente. Para fazer isso, vá para: Página Inicial do Centro de Privilégios > Benefícios para Membros > Ativar Resgate Automático de Cupons > Selecionar Cupons para Resgate Automático > Confirmar.',
        'vi-VN':
          'Chỉ huy thân mến:\n\nCảm ơn bạn đã luôn ủng hộ! Hệ thống "Trung tâm quyền lợi" mới đã chính thức ra mắt, phiếu ưu đãi "Hoạt động điểm VIP" cũ sẽ ngừng phát hành vào lúc 10 giờ (UTC) ngày 25 tháng 7 năm 2025, vui lòng đến hệ thống "Trung tâm quyền lợi" mới để đổi phiếu ưu đãi VIP.\n\nLưu ý: Tính năng tự động phát phiếu ưu đãi cần được mở thủ công, đường dẫn bật: Trang chủ Trung tâm quyền lợi - Xem quyền lợi hội viên - Tự động phát phiếu ưu đãi - Nhấn để mở - Chọn phiếu ưu đãi cần tự động đổi - Xác nhận mở',
        'th-TH':
          'ผู้บัญชาการที่เคารพ:\n\nขอบคุณสำหรับการสนับสนุนเสมอมา! ระบบ「ศูนย์สิทธิประโยชน์」โฉมใหม่เปิดให้บริการแล้ว คูปองจาก「กิจกรรมแต้ม VIP」เดิมจะหยุดแจกในวันที่ 2025/7/25 เวลา 10:00 (UTC) โปรดไปที่ระบบ「ศูนย์สิทธิประโยชน์」ใหม่เพื่อแลกคูปอง VIP\n\nหมายเหตุ: ฟังก์ชั่นการแจกตั๋วโปรโมชั่นอัตโนมัติต้องเปิดใช้งานด้วยตนเอง มีขั้นตอนดังนี้: หน้าแรกศูนย์สิทธิประโยชน์ - ดูสิทธิประโยชน์สมาชิก - การแจกตั๋วโปรโมชั่นอัตโนมัติ - คลิกเปิด - เลือกตั๋วโปรโมชั่นที่ต้องการแลกอัตโนมัติ - ยืนยันการเปิดใช้งาน',
        'ja-JP':
          '親愛なる指揮官様：\n\n日頃よりご愛顧いただき、誠にありがとうございます。「プレミアムセンター」システムが新たに稼働いたしました。従来の「VIPポイントキャンペーン」のクーポンは2025年7月25日10時（UTC）をもって配布を終了いたします。新しい「プレミアムセンター」システムにてVIPクーポンをお引き換えください。\n\nご注意：クーポンの自動発行機能は手動で開始する必要があります。開始手順は以下の通りです：プレミアムセンターのトップページ - 会員特典を確認 - クーポン自動発行 - 開始をクリック - 自動交換したいクーポンを選択 - 開始を確認',
        'ko-KR':
          '지휘관님께:\n\n항상 보내주시는 성원에 감사드립니다! [프리미엄 센터] 시스템이 새롭게 오픈되었습니다. 기존 [VIP 포인트 이벤트] 쿠폰은 2025년 7월 25일 10시(UTC)부로 발급이 중단되오니, 새로운 [프리미엄 센터] 시스템에서 VIP 쿠폰으로 교환해 주시기 바랍니다.\n\n주의 사항: 쿠폰 자동 발급 기능은 수동으로 활성화해야 합니다. \n\n활성화 경로: 혜택 센터 홈 - 회원 혜택 보기 - 쿠폰 자동 발급 - 활성화 클릭 - 자동 교환할 쿠폰 선택 - 활성화 확인',
        'ru-RU': `Здравствуйте, Командир!\n\nБлагодарим за вашу поддержку! Новый Центр привилегий уже открыт. Выдача купонов в рамках события VIP-очков прекращается 25 июля 2025 года в 10:00 (UTC). Пожалуйста, перейдите в новый Центр привилегий, чтобы использовать свои VIP-купоны.\n\nПримечание: автоматическое применение купонов нужно включить вручную. Для этого перейдите: Главная страница Центра привилегий > Бонусы участника > Включить Автопогашение купонов > Выберите купоны для автоматического использования > Подтвердить.`,
        'de-DE':
          'Hallo Kommandeur!\n\nVielen Dank für deine anhaltende Unterstützung! Das neue Privilegzentrum ist jetzt online. Die ursprünglichen VIP-Punkte-Event-Coupons werden nach dem 25. Juli 2025 um 10:00 Uhr (UTC) nicht mehr verteilt. Bitte begib dich zum neuen Privilegzentrum, um deine VIP-Coupons einzulösen.\n\nHinweis: Die automatische Coupon-Einlösungsfunktion muss manuell aktiviert werden. Um dies zu tun, gehe zu: Privilegzentrum Startseite > Mitgliedervorteile > Auto-Einlösen-Coupons aktivieren > Coupons für Auto-Einlösung auswählen > Bestätigen.',
        'it-IT': `Saluti, Comandante!\n\nTi ringraziamo per la tua fedeltà! Il nuovo Centro Privilegi è ora attivo. La distribuzione dei buoni dell'Evento Punti VIP cesserà alle 10:00 (UTC) del 25/7/2025. Recati al nuovo Centro Privilegi per riscattare i tuoi buoni VIP.\n\nNota: La funzione di riscossione automatica dei buoni deve essere attivata manualmente. Per farlo, andare su: Homepage Centro Privilegi > Benefici Membri > Abilita Riscatto Automatico Buoni > Seleziona Buoni da Riscattare Automaticamente > Conferma.`,
        'pl-PL':
          'Drogi Dowódco!\n\nDziękujemy za Twoje nieustające wsparcie! Nowe Centrum Przywilejów jest już dostępne. Dotychczasowe kupony z Wydarzenia Punktów VIP nie będą już przyznawane po 25 lipca 2025 o godzinie 10:00 (UTC). Prosimy o odwiedzenie nowego Centrum Przywilejów w celu wymiany kuponów VIP.\n\nUwaga: funkcję automatycznego odbioru kuponów należy aktywować ręcznie. W tym celu przejdź do: Strona główna Centrum Przywilejów > Korzyści złonków > Włącz automatyczne odbieranie kuponów > Wybierz kupony do automatycznego odbioru > Potwierdź.',
        'ar-SA':
          'عزيزي القائد:\n\nنشكركم على دعمكم المستمر! لقد تم إطلاق نظام "مركز الفوائد" الجديد، وستتوقف عملية إصدار القسائم الخاصة بنشاط "النقاط VIP" في 2025/7/25 الساعة 10 صباحًا (UTC). يرجى الذهاب إلى النظام الجديد "مركز الفوائد" لتبادل قسائم VIP.\n\nيرجى ملاحظة: وظيفة إصدار القسائم تلقائيًا يجب تمكينها يدويًا. مسار التمكين هو: الصفحة الرئيسية لمركز الفوائد - عرض فوائد الأعضاء - إصدار القسيمة التلقائي - انقر للتمكين - حدد القسيمة التي سيتم مبادلتها تلقائيًا - تأكيد التمكين',
        'id-ID':
          'Komandan terhormat:\n\nTerima kasih atas dukungan Anda selama ini! Sistem "Pusat Benefit" baru telah diluncurkan. Kupon "Acara Poin VIP" lama akan berhenti diberikan pada 25/7/2025 pukul 10.00 (UTC). Silakan kunjungi sistem "Pusat Benefit" baru untuk menukarkan kupon VIP.\n\nPerhatian: Fitur pemberian kupon otomatis perlu diaktifkan secara manual. Cara mengaktifkan: Halaman utama Pusat Benefit - Lihat benefit anggota - Pemberian kupon otomatis - Klik aktifkan - Pilih kupon yang ingin ditukar otomatis - Konfirmasi pengaktifan'
      };
      return language[this.lang] || language['en-US'];
    },
    pnsCloseCouponSendTitle() {
      const language = {
        'en-US': `Privilege Center Automatic Coupon Redemption Feature to Be Disabled`,
        'es-ES': `La función de canje automático de cupones del Centro de Privilegios será desactivada`,
        'tr-TR': `Ayrıcalık Merkezi Otomatik Kupon Kullanma Özelliği Devre Dışı Bırakılacak`,
        'zh-CN': `关于【权益中心】优惠券自动兑换功能关闭提醒`,
        'zh-TW': `關於【權益中心】優惠券自動兌換功能關閉提醒`,
        'fr-FR': `Désactivation de la fonction d'utilisation automatique des coupons du Centre de Privilèges`,
        'pt-PT': `Recurso de Resgate Automático de Cupom do Centro de Privilégios Será Desativado`,
        'vi-VN': `Thông báo đóng tính năng tự động đổi phiếu giảm giá tại [Trung Tâm Quyền Lợi]`,
        'th-TH': `แจ้งเตือนการปิดฟังก์ชันแลกคูปองอัตโนมัติของ [ศูนย์สิทธิประโยชน์]`,
        'ja-JP': `「プレミアムセンター」のクーポン自動交換機能終了のお知らせ`,
        'ko-KR': `[프리미엄 센터] 쿠폰 자동 교환 기능 종료 안내`,
        'ru-RU': `Автоматическое применение купонов в Центре привилегий будет отключено`,
        'de-DE': `Automatische Gutscheineinlösung im Privilegienzentrum wird deaktiviert`,
        'it-IT': `Centro Privilegi: disattivazione del riscatto automatico dei coupon`,
        'pl-PL': `Funkcja automatycznego wykorzystywania kuponów w Centrum Przywilejów zostanie wyłączona`,
        'ar-SA': `بشأن إغلاق وظيفة الاستبدال التلقائي للقسائم في [مركز الامتيازات]`,
        'id-ID': `Pengingat penonaktifan fitur penukaran otomatis kupon di [Pusat Hak Istimewa]`
      };
      return language[this.lang] || language['en-US'];
    },
    pnsCloseCouponSendContent() {
      const language = {
        'en-US': `Greetings, Commander!\n\nThank you for your continued support! Due to upcoming system updates to the Privilege Center, the Automatic Coupon Redemption feature will be disabled at 0:00 (UTC) on July 30, 2025. After this change, please visit Privilege Center > Points Mall to redeem your coupons. We appreciate your understanding!`,
        'es-ES': `¡Hola, comandante!\n\n¡Gracias por tu continuo apoyo! Debido a las próximas actualizaciones del sistema en el Centro de Privilegios, la función de canje automático de cupones se desactivará a las 0:00 (UTC) del 30 de julio de 2025. Después de este cambio, visita el Centro de Privilegios > Centro comercial de Puntos para canjear tus cupones. ¡Agradecemos tu comprensión!`,
        'tr-TR': `Selamlar Kumandan!\n\nSüregelen desteğiniz için teşekkürler! Ayrıcalık Merkezi'ndeki yaklaşan sistem güncellemeleri nedeniyle, Otomatik Kupon Kullanma özelliği 30 Temmuz 2025 00.00'de (UTC) devre dışı bırakılacak. Bu değişiklikten sonra, lütfen kuponlarınızı kullanmak için Ayrıcalık Merkezi > Puan AVM'sini ziyaret edin. Anlayışınız için teşekkür ederiz!`,
        'zh-CN': `尊敬的指挥官：\n\n感谢您一直以来的支持！由于「权益中心」系统功能更新，自动发放优惠券功能将于2025年7月30日 0:00（UTC）关停，后续请通过「权益中心」-「积分商城」页面兑换优惠券，敬请留意。`,
        'zh-TW': `尊敬的指揮官：\n\n感謝您一直以來的支持！由於「權益中心」系統功能更新，自動發放優惠券功能將於2025年7月30日 0:00（UTC）關停，後續請透過「權益中心」-「積分商城」頁面兌換優惠券，敬請留意。`,
        'fr-FR': `Salutations, Commandant !\n\nMerci de votre fidélité ! En raison de mises à jour du système du Centre de Privilèges, la fonction d'utilisation automatique des coupons sera désactivée le 30/07/2025 à 0:00 (UTC). Après cette modification, veuillez vous rendre dans Centre de Privilèges > Centre commercial des Points pour utiliser vos coupons. Merci de votre compréhension !`,
        'pt-PT': `Saudações, Comandante!\n\nObrigado por seu apoio contínuo! Devido às próximas atualizações do sistema no Centro de Privilégios, o recurso de Resgate Automático de Cupom será desativado às 0:00 (UTC) em 30 de julho de 2025. Após essa alteração, visite Centro de Privilégios > Centro Comercial de Pontos para resgatar seus cupons. Agradecemos sua compreensão!`,
        'vi-VN': `Chỉ huy thân mến:\n\nCảm ơn bạn đã luôn ủng hộ! Do cập nhật hệ thống của "Trung Tâm Quyền Lợi", tính năng tự động phát hành phiếu giảm giá sẽ bị đóng vào lúc 0:00 (UTC) ngày 30 tháng 7 năm 2025. Sau đó, vui lòng đổi phiếu giảm giá tại trang "Trung Tâm Quyền Lợi" - "Cửa hàng Điểm". Vui lòng lưu ý.`,
        'th-TH': `ผู้บัญชาการที่เคารพ:\n\nขอบคุณที่ให้การสนับสนุนเสมอมา! เนื่องจากการอัปเดตระบบของ「ศูนย์สิทธิประโยชน์」 ฟังก์ชันแจกคูปองอัตโนมัติจะปิดให้บริการในวันที่ 2025/7/30 เวลา 0:00(UTC) หลังจากนี้ โปรดแลกรับคูปองด้วยตนเองที่หน้า「ศูนย์สิทธิประโยชน์」-「มอลล์แต้ม」 จึงเรียนมาเพื่อทราบ`,
        'ja-JP': `親愛なる指揮官様：\n\n日頃より格別のご愛顧を賜り、誠にありがとうございます。「プレミアムセンター」のシステム機能更新に伴い、クーポンの自動発行機能を2025年7月30日 0:00（UTC）をもって終了させていただきます。今後はクーポンの交換を「プレミアムセンター」の「ポイントショップ」ページにて行っていただきますよう、何卒ご了承ください。`,
        'ko-KR': `안녕하세요, 지휘관님.\n\n프리미엄 센터' 시스템 기능 개편으로 인해 쿠폰 자동 지급 기능이 2025년 7월 30일 0:00(UTC)부로 종료될 예정입니다. 이후 쿠폰은 '프리미엄 센터' - '포인트 상점' 페이지에서 교환하실 수 있으니 참고 부탁드립니다.`,
        'ru-RU': `Здравствуйте, Командир!\n\nБлагодарим за вашу поддержку! В связи с предстоящим обновлением системы Центра привилегий функция автоматического применения купонов будет отключена 30/07/2025 в 0:00 (UTC). После этого изменения купоны можно будет активировать вручную в разделе «Центр привилегий» > «Магазин очков». Благодарим за понимание!`,
        'de-DE': `Hallo Kommandeur!\n\nVielen Dank für Ihre anhaltende Unterstützung! Aufgrund bevorstehender Systemaktualisierungen im Privilegienzentrum wird die automatische Gutscheineinlösung am 30. Juli 2025 um 0:00 Uhr (UTC) deaktiviert. Nach dieser Änderung besuchen Sie bitte das Privilegienzentrum > Punkte-Mall, um Ihre Gutscheine einzulösen. Wir danken Ihnen für Ihr Verständnis!`,
        'it-IT': `Saluti, Comandante!\n\nGrazie per il tuo costante supporto! A seguito dei prossimi aggiornamenti di sistema del Centro Privilegi, la funzione di riscatto automatico dei coupon verrà disattivata alle 0:00 (UTC) del 30/07/2025. Al termine della modifica, visita Centro Privilegi > Centro Commerciale Punti per riscattare i tuoi coupon. Grazie per la comprensione`,
        'pl-PL': `Witaj, Dowódco!\n\nDziękujemy za nieustające wsparcie! Ze względu na nadchodzące aktualizacje systemu w Centrum Przywilejów, funkcja automatycznego wykorzystywania kuponów zostanie wyłączona o 0:00 (UTC) 30 lipca 2025 roku. Po tej zmianie prosimy odwiedzić Centrum Przywilejów > Market Punktów, aby wykorzystać swoje kupony. Doceniamy Twoje zrozumienie!`,
        'ar-SA': `عزيزي القائد:\n\nنشكرك على دعمك المستمر! نظرًا لتحديث وظائف نظام "مركز الامتيازات"، سيتم إيقاف وظيفة توزيع القسائم تلقائيًا في 2025/7/30 0:00 (UTC)، يرجى متابعة استبدال القسائم عبر صفحة "مركز الامتيازات" - "المتجر النقاط"، نرجو الانتباه.`,
        'id-ID': `Komandan terhormat:\n\nTerima kasih atas dukungan Anda selama ini! Karena pembaruan sistem "Pusat Hak Istimewa", fitur pemberian kupon otomatis akan dinonaktifkan pada 30/7/2025 0:00 (UTC). Selanjutnya, silakan tukarkan kupon melalui halaman "Mall Poin" di "Pusat Hak Istimewa". Harap perhatikan.`
      };
      return language[this.lang] || language['en-US'];
    },
    bzitNoticeTitle() {
      const language = {
        'en-US': `[Z-BIT] Discontinuation Notice`,
        'es-ES': ``,
        'tr-TR': ``,
        'zh-CN': `【Z-BIT】下架通知`,
        'zh-TW': `【Z-BIT】下架通知`,
        'fr-FR': ``,
        'pt-PT': ``,
        'vi-VN': `Thông báo ngừng cung cấp [Z-BIT]`,
        'th-TH': `ประกาศยุติ [Z-BIT]`,
        'ja-JP': `【Z-BIT】終了のお知らせ`,
        'ko-KR': `[Z-BIT] 서비스 종료 안내`,
        'ru-RU': ``,
        'de-DE': ``,
        'it-IT': ``,
        'pl-PL': ``,
        'ar-SA': `إشعار إزالة [Z-BIT]`,
        'id-ID': `[Z-BIT] Pemberitahuan Penarikan`
      };
      return language[this.lang] || language['en-US'];
    },
    bzitNoticeContent() {
      const language = {
        'en-US': `Greetings, Commander. \n\nThank you for supporting [Z-BIT]. Due to an upcoming service upgrade, we regret to inform you that the [Z-BIT] top-up function will be disabled on August 18, 2025, at 00:00 (UTC). Please note that your [Z-BIT] balance can still be used.\n\nAs of January 1, 2026, 00:00 (UTC), [Z-BIT] will be permanently discontinued. Please use your remaining [Z-BIT] balance before this time. Unused balanced will be lost and cannot be recovered.\n\nIf you have any other questions, kindly contact our Customer Support. Thank you!`,
        'es-ES': ``,
        'tr-TR': ``,
        'zh-CN': `尊敬的指挥官：感谢一直以来对【Z-BIT】的支持，由于官网储值页面功能即将升级迭代，【Z-BIT】将会在2025年8月18日0点（UTC）下线充值功能；如果您的账号内仍有【Z-BIT】余额，可继续使用；\n\n自2026年1月1日0点（UTC）起，【Z-BIT】功能将永久下线，届时您剩余的【Z-BIT】余额将会清零，请尽快使用您【Z-BIT】余额，以免造成不必要损失，敬请留意。\n\n如有其他疑问，可联系客服咨询，感谢您对官网储值的支持。`,
        'zh-TW': `尊敬的指揮官：感謝您一直以來對【Z-BIT】的支持。由於官網儲值頁面功能即將升級迭代，【Z-BIT】將於2025年8月18日0時（UTC）停止充值功能。若您帳號內仍有【Z-BIT】餘額，可繼續使用。\n\n自2026年1月1日0時（UTC）起，【Z-BIT】功能將永久停用，屆時您剩餘的【Z-BIT】餘額將會歸零。請盡快使用您的【Z-BIT】餘額，以免造成不必要損失，敬請留意。\n\n如有其他疑問，可聯絡客服諮詢。感謝您對官網儲值的支持。`,
        'fr-FR': ``,
        'pt-PT': ``,
        'vi-VN': `Chỉ Huy thân mến: Cảm ơn ngài đã luôn ủng hộ [Z-BIT]. Do chức năng nạp tiền trên trang web chính thức sắp được nâng cấp và cải tiến, [Z-BIT] sẽ ngừng chức năng nạp tiền vào lúc 0h (UTC) ngày 18/08/2025. Nếu tài khoản của ngài vẫn còn số dư [Z-BIT], ngài vẫn có thể tiếp tục sử dụng.\n\nKể từ 0h (UTC) ngày 01/01/2026, chức năng [Z-BIT] sẽ vĩnh viễn ngừng hoạt động. Khi đó, số dư [Z-BIT] còn lại của ngài sẽ bị xóa. Vui lòng sử dụng số dư [Z-BIT] của ngài càng sớm càng tốt để tránh tổn thất không đáng có. Vui lòng lưu ý.\n\nNếu ngài có bất kỳ câu hỏi nào khác, vui lòng liên hệ với bộ phận CSKH. Cảm ơn ngài đã ủng hộ chức năng nạp tiền trên trang web chính thức.`,
        'th-TH': `ผู้บัญชาการที่เคารพ: ขอบคุณที่ให้การสนับสนุน [Z-BIT] มาโดยตลอด เนื่องด้วยจะมีการอัปเกรดหน้าเติมเงินบนเว็บไซต์ทางการ ฟังก์ชันเติมเงิน [Z-BIT] จึงจะปิดให้บริการในวันที่ 18 สิงหาคม 2025 เวลา 00:00 น.(UTC); หากบัญชีของคุณยังมียอด [Z-BIT] คงเหลือ จะยังคงใช้งานได้ต่อ;\n\nตั้งแต่วันที่ 1 มกราคม 2026 เวลา 00:00 น.(UTC) เป็นต้นไป ฟังก์ชัน [Z-BIT] จะยุติการให้บริการอย่างถาวร และยอด [Z-BIT] ที่เหลืออยู่ของคุณจะถูกรีเซ็ตเป็นศูนย์ กรุณารีบใช้ยอด [Z-BIT] ของคุณเพื่อหลีกเลี่ยงความสูญเสียที่ไม่จำเป็น จึงเรียนมาเพื่อทราบ\n\nหากมีข้อสงสัยเพิ่มเติม สามารถติดต่อฝ่ายบริการลูกค้าเพื่อสอบถาม ขอขอบคุณที่สนับสนุนการเติมเงินผ่านเว็บไซต์ทางการ`,
        'ja-JP': `指揮官の皆様、平素より【Z-BIT】をご利用いただき、誠にありがとうございます。公式サイトのチャージページ機能のアップグレードに伴い、【Z-BIT】を2025年8月18日0時（UTC）をもって終了させていただきます。なお、アカウント内に【Z-BIT】の残高がある場合は、引き続きご利用いただけます。\n\n2026年1月1日0時（UTC）より、【Z-BIT】機能を永久に終了させていただきます。その際、【Z-BIT】の残高は全て消滅いたしますので、お持ちの【Z-BIT】残高はお早めにご利用ください。不要な損失を避けるため、ご注意いただきますようお願い申し上げます。\n\nご不明な点がございましたら、カスタマーサポートまでお問い合わせください。公式サイトのチャージサービスへのご支援、誠にありがとうございます。`,
        'ko-KR': `안녕하세요, 지휘관님. [Z-BIT]를 지속적으로 이용해 주셔서 감사합니다. 공식 웹사이트의 충전 페이지 기능이 곧 업그레이드될 예정이어서, [Z-BIT]는 2025년 8월 18일 0시(UTC)부로 충전 기능을 종료할 예정입니다. 계정에 남아있는 [Z-BIT] 잔액은 계속 사용하실 수 있습니다.\n\n2026년 1월 1일 0시(UTC)부터 [Z-BIT] 기능이 영구적으로 종료되며, 그 시점에 남아있는 [Z-BIT] 잔액은 소멸됩니다. 불필요한 손실을 방지하기 위해 [Z-BIT] 잔액을 최대한 빨리 사용해 주시기 바랍니다.\n\n다른 문의 사항이 있으시면 고객 센터에 문의해 주시기 바랍니다. 공식 웹사이트 충전을 이용해 주셔서 감사합니다.`,
        'ru-RU': ``,
        'de-DE': ``,
        'it-IT': ``,
        'pl-PL': ``,
        'ar-SA': `عزيزي القائد: نشكركم على دعمكم المستمر لـ [Z-BIT]. نظرًا لأن وظيفة صفحة شحن الموقع الرسمي ستتم ترقيتها قريبًا، سيتم إيقاف وظيفة الشحن لـ [Z-BIT] في 2025/8/18 الساعة 0 صباحًا (UTC). إذا كان لديك رصيد [Z-BIT]، يمكنك الاستمرار في استخدامه.\n\nبدءًا من 2026/1/1 الساعة 0:00 (UTC)، سيتم إيقاف وظيفة [Z-BIT] بشكل دائم، وسيتم تصفير رصيد [Z-BIT] المتبقي لديك. يرجى استخدام رصيد [Z-BIT] الخاص بك في أقرب وقت ممكن لتجنب أي خسائر غير ضرورية. نرجو الانتباه.\n\nإذا كان لديك أي استفسارات أخرى، يمكنك التواصل مع خدمة العملاء للتقدم بالاستفسار. نشكركم على دعمكم لشحن الموقع الرسمي.`,
        'id-ID': `Komandan yang terhormat: Terima kasih atas dukungan Anda terhadap [Z-BIT]. Karena halaman top-up official akan segera diupgrade, fungsi top-up [Z-BIT] akan dihentikan pada 18/8/2025 pukul 00:00 (UTC). Jika akun Anda masih memiliki saldo [Z-BIT], Anda dapat terus menggunakannya.\n\nMulai 1/1/2026 pukul 00:00 (UTC), fitur [Z-BIT] akan dihentikan secara Permanen. Pada saat itu, sisa saldo [Z-BIT] Anda akan dihapus. Harap gunakan saldo [Z-BIT] Anda sesegera mungkin untuk menghindari kerugian yang tidak perlu. Mohon perhatikan hal ini.\n\nJika Anda memiliki pertanyaan lain, silakan hubungi layanan pelanggan. Terima kasih atas dukungan Anda terhadap sistem top-up official kami.`
      };
      return language[this.lang] || language['en-US'];
    },
    jpDownGame() {
      const TEXT_MAP = {
        209: {
          title: this.jpDownDaZhangGuiTitle,
          content: this.jpDownDaZhangGuiContent
        },
        337: {
          title: this.jpDownDaQianTitle,
          content: this.jpDownDaQianContent
        },
        2: {
          title: this.jpDownJiangmeiTitle,
          content: this.jpDownJiangmeiContent
        },
        382: {
          title: this.jpDownBaYeTitle,
          content: this.jpDownBaYeContent
        }
      };
      return TEXT_MAP[this.gameId] || { title: '', content: '' };
    },
    kOneDownLimitActivityButton() {
      const language = {
        'en-US': `Announcement`,
        'es-ES': `Anuncio de Ajuste`,
        'tr-TR': `Ayarlama Duyurusu`,
        'zh-CN': `调整公告`,
        'zh-TW': `調整公告`,
        'fr-FR': `Annonce de Régulation`,
        'pt-PT': `Anúncio de Ajuste`,
        'vi-VN': `Thông báo Điều chỉnh`,
        'th-TH': ``,
        'ja-JP': `お知らせ`,
        'ko-KR': `조정 공고`,
        'ru-RU': `Объявление об ajustировке`,
        'de-DE': `Anpassungsankündigung`,
        'it-IT': `Annuncio di Aggiustamento`,
        'pl-PL': ``,
        'ar-SA': ``,
        'id-ID': `Announcement`
      };
      return language[this.lang] || language['en-US'];
    },
    kOneDownLimitActivityTitle() {
      const language = {
        'en-US': `Official Top Up Center Exclusive Limited-Time Offer Adjustment`,
        'es-ES': `Ajuste de las ofertas exclusivas por tiempo limitado del Centro oficial de recargas`,
        'tr-TR': `Resmi Yükleme Merkezi Özel Sınırlı Süreli Teklif Düzenlemesi`,
        'zh-CN': `关于官方充值中心限时福利调整的公告`,
        'zh-TW': `關於官方充值中心限時福利調整的公告`,
        'fr-FR': `Ajustement des Offres exclusives en temps limité du Centre de Recharge officiel`,
        'pt-PT': `Ajuste de Oferta Exclusiva por Tempo Limitado no Centro de Recarga Oficial`,
        'vi-VN': `Thông báo điều chỉnh phúc lợi hạn giờ tại Trung tâm Nạp chính thức`,
        'th-TH': ``,
        'ja-JP': `公式チャージセンターの期間限定特典調整に関するお知らせ`,
        'ko-KR': `공식 충전 센터 기간 한정 혜택 조정에 관한 공지`,
        'ru-RU': `Изменение Особых временных предложений в Официальном Центре пополнения`,
        'de-DE': `Anpassung des exklusiven zeitlich begrenzten Angebots im offiziellen Aufladezentrum`,
        'it-IT': `Centro Ricariche Ufficiale: Modifiche all'Offerta Esclusiva a Tempo Limitato`,
        'pl-PL': ``,
        'ar-SA': ``,
        'id-ID': `Pengumuman Tentang Penyesuaian Benefit Waktu Terbatas di Pusat Top Up Resmi`
      };
      return language[this.lang] || language['en-US'];
    },
    kOneDownLimitActivityContent() {
      const language = {
        'en-US': `Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.`,
        'es-ES':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'tr-TR':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'zh-CN':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'zh-TW': `尊敬的領主，由於活動系統升級，我們將於2025/12/06 0:00（UTC）更新大會員中心優惠券減免金額上限；更新後優惠券減免上限如下：\n9% Off 優惠券 (減免上限 $99.99)\n11% Off 優惠券 (減免上限 $49.99)\n13% Off 優惠券 (減免上限 $19.99)\n減免金額受匯率波動影響，具體請以優惠券頁面為準，敬請留意。`,
        'fr-FR': `Cher Seigneur, en raison de la mise à niveau du système d'événements, nous mettrons à jour la limite de réduction des coupons dans le premium member center le 06/12/2025 à 0h00（UTC）. Les limites de réduction des coupons mises à jour sont les suivantes :\n9% Off Coupon (Limite de réduction $99.99)\n11% Off Coupon (Limite de réduction $49.99)\n13% Off Coupon (Limite de réduction $19.99)\nLe montant de la réduction est soumis aux fluctuations du taux de change. Veuillez consulter la page des coupons pour plus de détails.`,
        'pt-PT':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'vi-VN':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'th-TH': `Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.`,
        'ja-JP': `Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details`,
        'ko-KR': `존경하는 영주님, 이벤트 시스템 업그레이드로 인해 2025/12/06 0:00（UTC）에 혜택 센터 쿠폰 할인 한도를 업데이트할 예정입니다. 업데이트된 쿠폰 할인 한도는 다음과 같습니다:\n9% Off 쿠폰 (할인 한도 $99.99)\n11% Off 쿠폰 (할인 한도 $49.99)\n13% Off 쿠폰 (할인 한도 $19.99)\n할인 금액은 환율 변동에 따라 달라질 수 있으니 쿠폰 페이지를 참고하시기 바랍니다.`,
        'ru-RU': `Уважаемый лорд, в связи с обновлением системы мероприятий, 06.12.2025 в 00:00（UTC） мы обновим лимит скидок для купонов в premium member center. Обновленные лимиты скидок для купонов следующие:\n9% Off Купон (Лимит скидки $99.99)\n11% Off Купон (Лимит скидки $49.99)\n13% Off Купон (Лимит скидки $19.99)\nСумма скидки зависит от колебаний обменного курса. Пожалуйста, ознакомьтесь с подробностями на странице купонов.`,
        'de-DE': `Sehr geehrter Lord, aufgrund der Aktualisierung des Veranstaltungssystems werden wir am 06.12.2025 um 0:00（UTC） die Rabattgrenzen für Gutscheine im premium member center aktualisieren. Die aktualisierten Rabattgrenzen sind wie folgt:\n9% Off Gutschein (Rabattgrenze $99.99)\n11% Off Gutschein (Rabattgrenze $49.99)\n13% Off Gutschein (Rabattgrenze $19.99)\nDer Rabattbetrag unterliegt Wechselkursschwankungen. Bitte beachten Sie die Gutscheinseite für weitere Details.\n`,
        'it-IT':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.',
        'pl-PL': `Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.`,
        'ar-SA': `Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.`,
        'id-ID':
          'Dear Lord, due to the upgrade of the event system, we will update the discount limit for coupons in the premium member center on 2025/12/06 at 0:00（UTC）. The updated coupon discount limits are as follows:\n9% Off Top Up Coupon (Up to $99.99)\n11% Off Top Up Coupon (Up to $49.99)\n13% Off Top Up Coupon (Up to $19.99)\nThe discount amount is subject to exchange rate fluctuations. Please refer to the coupon page for details.'
      };
      return language[this.lang] || language['en-US'];
    },
    kOneDownVipTitle() {
      return (
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.[this.lang]
          ?.popupTitle ||
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.['en-US']
          ?.popupTitle ||
        ''
      );
    },
    kOneDownVipContent() {
      return (
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.[this.lang]
          ?.popupContent ||
        this.gameInfoConfig?.vipScoreDownIntro?.langMap?.['en-US']
          ?.popupContent ||
        ''
      );
    },
    jpPayDownContent() {
      const name = {
        191: {
          userName: '指揮官',
          maintainerName: 'パズル&サバイバル'
        },
        263: {
          userName: '統領',
          maintainerName: '立ち上がれ、アリ帝国'
        },
        175: {
          userName: 'ロード',
          maintainerName: 'パズル&コンクエスト'
        },
        285: {
          userName: 'ロード',
          maintainerName: 'パズル＆カオス'
        },
        331: {
          userName: '頭領',
          maintainerName: 'Primal Conquest: Dino Era'
        },
        209: {
          userName: '主人',
          maintainerName: '商人放浪記 - あきんどの成り上がり道'
        },
        337: {
          userName: '妖仙',
          maintainerName: '妖遊記~トントン名人になれ'
        },
        2: {
          userName: '旦那',
          maintainerName: '旦那様の一発逆転人生'
        },
        382: {
          userName: '主公',
          maintainerName: '爆速三国-フルスロットル'
        },
        255: {
          userName: '勇者',
          maintainerName: 'MU：アークエンジェル'
        }
      };
      const content = `親愛なる【userName】様：\n\n日頃のご愛顧誠にありがとうございます。より安全な決済環境を提供するため、\n【2025年12月1日 17:00(日本時間)】に以下の決済システム調整を実施いたします：\n公式サイトのチャージプラットフォーム【および / PCでの決済機能 / ブラウザゲームの決済機能】のサービスを終了\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\n終了後は以下の公式チャネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n注意事項\n1. 公式サイトのチャージクーポンの配布も同時に終了しますが、2025年12月1日 17:00(日本時間)までに受け取ったクーポンは有効期限まで使用可能です。\n2. 公式サイトのチャージプラットフォームで既にチャージしたゲーム内通貨やアイテムは引き続き通常通り使用できます。\n3. 一部の決済方法（コンビニ払い/クレジットカードなど）では入金に遅延が生じる場合があります。2025年12月1日 17:00(日本時間)までにチャージが反映されない場合（弊社で入金が確認できない場合）、そのチャージは自動的に無効となりますので、チャージのタイミングにご注意ください。\n\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援に重ねて感謝申し上げます。\n\n【maintainerName】運営チーム\n2025年11月24日`;
      const userName = name?.[+this.gameId]?.userName || '';
      const maintainerName = name?.[+this.gameId]?.maintainerName || '';
      return content
        .replace('userName', userName)
        .replace('maintainerName', maintainerName);
    },
    gameShowJpPayDown() {
      const gameId = +this.gameId;
      if ([263, 175, 285, 331, 209, 337, 2, 382, 255].includes(gameId)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    confirmRightsNotice() {
      openActivity(
        EVENT_LIST_ACTIVITY,
        `https://auto-page.${globalConfig.getMainHost()}/pnsvip01/`,
        {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        }
      );
      this.closeRightsNotice();
      this.closeCouponSend();
    },

    // 3、加关闭方法
    closeRightsNotice() {
      this.visibleRightsNotice = false;
    },
    closeCouponSend() {
      this.visibleCloseCouponSend = false;
    },
    closePayPalNotice() {
      this.visiblePayPalNotice = false;
    },
    closeBzitNotice() {
      this.visibleBzitNotice = false;
    },
    closeDownJpPayType() {
      this.visibleDownJpPayType = false;
    },
    closeBankPayDown() {
      this.visibleBankPayDown = false;
    },
    closeMayiPayDown() {
      this.visibleMayiPayDown = false;
    },
    closePnsPayDown() {
      this.visiblePnsPayDown = false;
    },
    closeKoDzgNotice() {
      this.visibleKoDzgNotice = false;
    },
    closePnsPayNoticeDown() {
      this.visiblePnsPayNoticeDown = false;
    },
    closeJpGamePayDown() {
      this.visibleJpGamePayDown = false;
    },
    closeDzgJpExtraCoinDown() {
      this.visibleDzgJpExtraCoinDown = false;
    },
    closeMayiKoNotice() {
      this.visibleMayiKoNotice = false;
    },
    closeMayiPayChangeNotice() {
      this.visibleMayiPayChangeNotice = false;
    },
    closeJiangMeiExtraCoinDown() {
      this.visibleJiangMeiExtraCoinDown = false;
    },
    closeKOneDownLimitActivity() {
      this.visibleKOneDownLimitActivity = false;
    },
    closeKOneDownVip() {
      this.visibleKOneDownVip = false;
    },
    closeDzgJpCouponDown() {
      this.visibleDzgJpCouponDown = false;
    },
    closeJiangmeiCouponDown() {
      this.visibleJiangmeiCouponDown = false;
    },

    // 检查是否在展示时间范围内
    isInDisplayPeriod(startTime, endTime) {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);
      return now >= startDate && now <= endDate;
    },

    // 获取当前UTC日期字符串 (YYYY-MM-DD)
    getCurrentUTCDateString() {
      const now = new Date();
      return now.toISOString().split('T')[0];
    },

    // 检查今天是否已经弹出过
    hasShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      const lastShownDate = globalConfig.getCookie(cookieName);
      return lastShownDate === today;
    },

    // 记录今天已经弹出
    markAsShownToday(cookieName) {
      const today = this.getCurrentUTCDateString();
      globalConfig.setCookie(cookieName, today);
    },

    // 检查是否应该显示弹窗
    shouldShowPopup(startTime, endTime, cookieName) {
      // 1. 检查是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false;
      }
      // 2. 检查今天是否已经弹出过
      if (this.hasShownToday(cookieName)) {
        return false;
      }
      return true;
    },

    // 新增：检查是否应该显示弹窗（每日一次，总共最多3次）
    shouldShowPopupWithLimit(
      startTime,
      endTime,
      dateCookieName,
      countCookieName,
      maxCount = 3
    ) {
      // 1. 检查是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false;
      }

      // 2. 检查今天是否已经弹出过
      if (this.hasShownToday(dateCookieName)) {
        return false;
      }

      // 3. 检查总弹出次数是否达到上限
      const totalCount = parseInt(
        globalConfig.getCookie(countCookieName) || '0'
      );
      if (totalCount >= maxCount) {
        return false;
      }

      return true;
    },

    // 新增：记录弹出并增加计数
    markAsShownTodayWithCount(dateCookieName, countCookieName) {
      // 记录今天已弹出
      this.markAsShownToday(dateCookieName);

      // 增加总计数
      const currentCount = parseInt(
        globalConfig.getCookie(countCookieName) || '0'
      );
      globalConfig.setCookie(countCookieName, (currentCount + 1).toString());
    },
    // 新增：每7个自然日内仅弹出一次（无总次数限制）
    // 使用规则：在指定时间段内，若距离上次弹出已满7天，则允许再次弹出
    shouldShowPopupEvery7Days(startTime, endTime, dateCookieName) {
      // 1. 是否在展示时间范围内
      if (!this.isInDisplayPeriod(startTime, endTime)) {
        return false;
      }

      // 2. 读取上次弹出日期（UTC日期字符串，格式：YYYY-MM-DD）
      const lastShownDateStr = globalConfig.getCookie(dateCookieName);
      if (!lastShownDateStr) {
        // 从未展示过，允许展示
        return true;
      }

      // 3. 计算与今天（UTC日）的自然日差值
      const todayStr = this.getCurrentUTCDateString();
      const todayUTC = new Date(`${todayStr}T00:00:00Z`);
      const lastShownUTC = new Date(`${lastShownDateStr}T00:00:00Z`);

      const diffMs = todayUTC.getTime() - lastShownUTC.getTime();
      const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));

      // 满7天（含）后允许再次展示
      return diffDays >= 7;
    },
    closeJpPayDown() {
      this.visibleJpPayDown = false;
    }
  },
  mounted() {
    // 4、加初始化逻辑

    // 指定时间段内只弹窗一次
    // if (
    //   this.shouldShowPopup(
    //     '2025-07-25T10:00:00Z',
    //     '2025-07-29T23:59:59Z',
    //     'pns_rights_popup_last_shown'
    //   ) &&
    //   this.gameId == 191
    // ) {
    //   this.visibleRightsNotice = true;
    //   this.markAsShownToday('pns_rights_popup_last_shown');
    // }

    // 指定时间段内，每个自然日弹出一次，总共最多弹出3次
    if (
      this.shouldShowPopupWithLimit(
        '2025-07-30T00:00:00Z',
        '2025-08-05T23:59:59Z',
        'pns_close_coupon_send_last_shown',
        'pns_close_coupon_send_count'
      ) &&
      this.gameId == 191
    ) {
      this.visibleCloseCouponSend = true;
      this.markAsShownTodayWithCount(
        'pns_close_coupon_send_last_shown',
        'pns_close_coupon_send_count'
      );
    }

    // 是日语或者是日本ip在固定时间段内，按游戏独立判断是否弹过
    if (
      this.isInDisplayPeriod(
        '2025-07-29T11:00:00+09:00',
        '2025-08-02T11:00:00+09:00'
      ) &&
      globalConfig.getCookie(`paypal_notice_shown_${this.gameId}`) != '1' &&
      this.$store?._actions?.[CHECK_IP_LOCATION] &&
      [
        // V1支付页
        191, 285, 263, 209,
        // V2支付页
        382, 337, 331, 175
      ].includes(Number(this.gameId))
    ) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res?.ISO_TWO_CODE === 'JP' || this.lang === 'ja-JP') {
          this.visiblePayPalNotice = true;
          globalConfig.setCookie(`paypal_notice_shown_${this.gameId}`, '1');
        }
      });
    }

    if (
      window.isOfficialStore &&
      this.$route?.name == 'wallet' &&
      this.shouldShowPopupWithLimit(
        '2025-08-04T00:00:00Z',
        '2025-08-17T23:59:59Z',
        'pns_close_bzit_notice_last_shown',
        'pns_close_bzit_notice_count',
        1
      ) &&
      this.gameId == 191
    ) {
      this.visibleBzitNotice = true;
      this.markAsShownTodayWithCount(
        'pns_close_bzit_notice_last_shown',
        'pns_close_bzit_notice_count'
      );
    }

    // 是日语或者是日本ip在固定时间段内，按游戏独立判断是否弹过
    if (
      this.isInDisplayPeriod(
        '2025-07-29T11:00:00+09:00',
        '2025-08-22T11:00:00+09:00'
      ) &&
      globalConfig.getCookie(`jp_pay_type_down${this.gameId}`) != '1' &&
      this.$store?._actions?.[CHECK_IP_LOCATION] &&
      ((window.isOfficialStore &&
        [285, 263, 209].includes(Number(this.gameId))) ||
        (window.isOfficialWebStore &&
          [382, 337, 331].includes(Number(this.gameId))))
    ) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res?.ISO_TWO_CODE === 'JP' || this.lang === 'ja-JP') {
          this.visibleDownJpPayType = true;
          globalConfig.setCookie(`jp_pay_type_down${this.gameId}`, '1');
        }
      });
    }

    // 银行汇款弹屏
    // if (
    //   this.isInDisplayPeriod(
    //     '2025-08-20T11:00:00+08:00',
    //     '2026-08-20T23:59:59+08:00'
    //   ) &&
    //   globalConfig.getCookie(`bank_pay_down${this.gameId}`) != '1' &&
    //   ((window.isOfficialStore &&
    //     [285, 213, 263, 191, 227, 284, 225].includes(Number(this.gameId))) ||
    //     (window.isOfficialWebStore &&
    //       [379, 335, 331, 295, 269, 251, 175].includes(Number(this.gameId)))) &&
    //   this.lang === 'zh-TW'
    // ) {
    //   this.visibleBankPayDown = true;
    //   globalConfig.setCookie(`bank_pay_down${this.gameId}`, '1');
    // }

    // 蚂蚁V1支付页日本地区下架三方支付功能弹窗
    if (
      this.isInDisplayPeriod(
        '2025-08-28T11:00:00+08:00',
        '2025-12-31T23:59:59+08:00'
      ) &&
      this.$store?._actions?.[CHECK_IP_LOCATION] &&
      Number(this.gameId) === 263 &&
      window.isOfficialStore
    ) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res?.ISO_TWO_CODE === 'JP' || this.lang === 'ja-JP') {
          // 按钮展示到2025年12月31日
          this.visibleMayiPayDownButton = true;

          const dateCookieName = `mayi_notice_shown_${this.gameId}_mark`;
          const countCookieName = `mayi_notice_shown_${this.gameId}_count`;

          // 弹窗自动弹出到2025年9月3日
          // 9.1每次进来都弹出
          if (new Date()?.toISOString?.()?.split?.('T')?.[0] === '2025-09-01') {
            this.visibleMayiPayDown = true;
          } else if (
            this.shouldShowPopupWithLimit(
              '2025-08-28T11:00:00+08:00',
              '2025-09-03T23:59:59+08:00',
              dateCookieName,
              countCookieName,
              3
            )
          ) {
            this.visibleMayiPayDown = true;
            this.markAsShownTodayWithCount(dateCookieName, countCookieName);
          }
        }
      });
    }

    // PNSV1支付页日本地区下架三方支付功能弹窗
    if (
      this.isInDisplayPeriod(
        '2025-09-24T12:00:00+08:00',
        '2025-12-31T23:59:59+08:00'
      ) &&
      Number(this.gameId) === 191 &&
      (window.isOfficialStore || window.isOfficialTopupNew)
    ) {
      if (this.lang === 'ja-JP') {
        // 按钮展示到2025年12月31日
        this.visiblePnsPayDownButton = true;

        const dateCookieName = `pns_notice_shown_${this.gameId}_mark`;
        const countCookieName = `pns_notice_shown_${this.gameId}_count`;

        // 弹窗自动弹出到2025年9月29日
        if (
          this.shouldShowPopupWithLimit(
            '2025-09-24T10:00:00+08:00',
            '2025-12-31T23:59:59+08:00',
            dateCookieName,
            countCookieName,
            100000
          )
        ) {
          this.visiblePnsPayDown = true;
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }

    // 韩国大掌柜弹窗
    if (
      this.isInDisplayPeriod(
        '2025-08-27T11:00:00+08:00',
        '2025-09-27T23:59:59+08:00'
      ) &&
      globalConfig.getCookie(`ko_dzg_notice_${this.gameId}`) != '1' &&
      window.isOfficialStore &&
      Number(this.gameId) === 211 &&
      this.lang === 'ko-KR'
    ) {
      this.visibleKoDzgNotice = true;
      globalConfig.setCookie(`ko_dzg_notice_${this.gameId}`, '1');
    }

    /**
     * 背景：发布三方支付下线预告，以为后续其他调整措施提供口径依托
     *
     * -弹出周期：9/2 11:00 - 9/10 23:59 (utc+8)
     * -弹出频率：9/2每次打开均弹出，9/3-9/10期间每日弹出一次
     *
     * 叫我大掌柜_日语版（209）：V1
     * 寻道大千_日语版（337）：V2
     * 江山美人_日语版（2）：v3
     * 霸业2.0_日语版（382）：V2
     */

    const dzgBool = this.gameId == 209 && window.isOfficialStore;
    const xdqBool = this.gameId == 337 && window.isOfficialWebStore;
    const jmBool = this.gameId == 2 && window.isOfficialTopup;
    const byBool = this.gameId == 382 && window.isOfficialWebStore;

    if (
      this.isInDisplayPeriod(
        '2025-09-02T11:00:00+08:00',
        '2025-09-10T23:59:59+08:00'
      ) &&
      (dzgBool || xdqBool || jmBool || byBool)
    ) {
      const dateCookieName = `jp_game_pay_down_${this.gameId}_mark`;
      const countCookieName = `jp_game_pay_down_${this.gameId}_count`;

      if (new Date()?.toISOString?.()?.split?.('T')?.[0] === '2025-09-02') {
        this.visibleJpGamePayDown = true;
      } else if (
        this.shouldShowPopupWithLimit(
          '2025-09-03T00:00:00+08:00',
          '2025-09-10T23:59:59+08:00',
          dateCookieName,
          countCookieName,
          8
        )
      ) {
        this.visibleJpGamePayDown = true;
        this.markAsShownTodayWithCount(dateCookieName, countCookieName);
      }
    }

    // PNS日本渠道下架通知
    if (
      window.isOfficialStore &&
      this.gameId == 191 &&
      this.shouldShowPopupWithLimit(
        '2025-09-05T00:00:00+09:00',
        '2025-09-12T23:59:59+09:00',
        'pns_notice_jp_down_last_shown',
        'pns_notice_jp_down_count',
        8
      ) &&
      this.$store?._actions?.[CHECK_IP_LOCATION]
    ) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res?.ISO_TWO_CODE === 'JP' || this.lang === 'ja-JP') {
          this.visiblePnsPayNoticeDown = true;
          this.markAsShownTodayWithCount(
            'pns_notice_jp_down_last_shown',
            'pns_notice_jp_down_count'
          );
        }
      });
    }

    // 日本大掌柜加码下架
    if (
      this.isInDisplayPeriod(
        '2025-09-24T14:00:00+08:00',
        '2025-10-08T23:59:59+08:00'
      ) &&
      this.gameId == 209 &&
      window.isOfficialStore
    ) {
      if (
        this.isInDisplayPeriod(
          '2025-09-24T14:00:00+08:00',
          '2025-09-26T23:59:59+08:00'
        )
      ) {
        //  每次进来都弹出
        this.visibleDzgJpExtraCoinDown = true;
      } else {
        const dateCookieName = `dzg_jp_extra_coin_down_${this.gameId}_mark`;
        const countCookieName = `dzg_jp_extra_coin_down_${this.gameId}_count`;

        if (
          this.shouldShowPopupWithLimit(
            '2025-09-27T00:00:00+08:00',
            '2025-10-08T23:59:59+08:00',
            dateCookieName,
            countCookieName,
            15
          )
        ) {
          this.visibleDzgJpExtraCoinDown = true;
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }

    // 蚂蚁韩国韩元价格调整通知
    if (
      this.isInDisplayPeriod(
        '2025-09-26T11:00:00+08:00',
        '2025-10-26T23:59:59+08:00'
      ) &&
      Number(this.gameId) === 263 &&
      (window.isOfficialStore || window.isOfficialTopupNew) &&
      this.lang === 'ko-KR'
    ) {
      this.visibleMayiKoNoticeButton = true;

      const dateCookieName = `mayi_ko_notice_${this.gameId}_mark`;
      const countCookieName = `mayi_ko_notice_${this.gameId}_count`;
      if (
        this.shouldShowPopupWithLimit(
          '2025-09-26T11:00:00+08:00',
          '2025-10-02T23:59:59+08:00',
          dateCookieName,
          countCookieName,
          7
        )
      ) {
        this.visibleMayiKoNotice = true;
        this.markAsShownTodayWithCount(dateCookieName, countCookieName);
      }
    }

    // 蚂蚁日本地区储值调整
    if (
      this.shouldShowPopupWithLimit(
        '2025-09-29T00:00:00+09:00',
        '2025-10-05T23:59:59+09:00',
        `mayi_pay_change_${this.gameId}_mark`,
        `mayi_pay_change_${this.gameId}_count`,
        7
      ) &&
      this.gameId == 263 &&
      this.lang === 'ja-JP' &&
      (window.isOfficialStore || window.isOfficialTopupNew)
    ) {
      this.visibleMayiPayChangeNotice = true;
      this.markAsShownTodayWithCount(
        `mayi_pay_change_${this.gameId}_mark`,
        `mayi_pay_change_${this.gameId}_count`
      );
    }

    // 日本江美加码下架
    if (
      this.isInDisplayPeriod(
        '2025-10-13T14:00:00+08:00',
        '2025-10-26T23:59:59+08:00'
      ) &&
      window.isOfficialTopup &&
      this.gameId == 2
    ) {
      if (
        this.isInDisplayPeriod(
          '2025-10-13T14:00:00+08:00',
          '2025-10-16T23:59:59+08:00'
        )
      ) {
        this.visibleJiangMeiExtraCoinDown = true;
      } else {
        const dateCookieName = `jiang_mei_extra_coin_down_${this.gameId}_mark`;
        const countCookieName = `jiang_mei_extra_coin_down_${this.gameId}_count`;

        if (
          this.shouldShowPopupWithLimit(
            '2025-10-17T00:00:00+08:00',
            '2025-10-26T23:59:59+08:00',
            dateCookieName,
            countCookieName,
            10
          )
        ) {
          this.visibleJiangMeiExtraCoinDown = true;
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }

    // K1限时活动下架
    if (
      this.isInDisplayPeriod(
        '2025-12-04T00:00:00+00:00',
        '2025-12-10T23:59:59+00:00'
      ) &&
      (window.isOfficialStore || window.isOfficialTopupNew) &&
      this.gameId == 285
    ) {
      // this.visibleKOneDownLimitActivityButton = true;
      const dateCookieName = `k1_down_limit_activity_coupon__mark`;
      const countCookieName = `k1_down_limit_activity_coupon_count`;
      if (
        this.shouldShowPopupWithLimit(
          '2025-12-04T00:00:00+00:00',
          '2025-12-10T23:59:59+00:00',
          dateCookieName,
          countCookieName,
          100000
        )
      ) {
        this.visibleKOneDownLimitActivity = true;
        this.markAsShownTodayWithCount(dateCookieName, countCookieName);
      }
    }

    // K1下架VIP积分系统
    if (
      this.shouldShowPopupEvery7Days(
        '2025-10-17T00:00:00+08:00',
        '2025-11-17T23:59:59+08:00',
        'k1_down_vip_mark'
      ) &&
      (window.isOfficialStore || window.isOfficialTopupNew) &&
      this.gameId == 285
    ) {
      this.visibleKOneDownVip = true;
      this.markAsShownToday('k1_down_vip_mark');
    }

    // 日本大掌柜优惠券下架
    if (
      this.isInDisplayPeriod(
        '2025-10-30T17:00:00+08:00',
        '2025-11-13T23:59:59+08:00'
      ) &&
      window.isOfficialStore &&
      this.gameId == 209
    ) {
      if (
        this.isInDisplayPeriod(
          '2025-10-30T17:00:00+08:00',
          '2025-11-06T23:59:59+08:00'
        )
      ) {
        this.visibleDzgJpCouponDown = true;
      } else {
        const dateCookieName = `dzgjp_coupon_down_${this.gameId}_mark`;
        const countCookieName = `dzgjp_coupon_down_${this.gameId}_count`;
        if (
          this.shouldShowPopupWithLimit(
            '2025-11-07T00:00:00+08:00',
            '2025-11-13T23:59:59+08:00',
            dateCookieName,
            countCookieName,
            7
          )
        ) {
          this.visibleDzgJpCouponDown = true;
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }

    // 日本江美优惠券下架
    if (
      this.isInDisplayPeriod(
        '2025-10-30T17:00:00+08:00',
        '2025-11-06T23:59:59+08:00'
      ) &&
      window.isOfficialTopup &&
      this.gameId == 2
    ) {
      if (
        this.isInDisplayPeriod(
          '2025-10-30T17:00:00+08:00',
          '2025-11-06T23:59:59+08:00'
        )
      ) {
        this.visibleJiangmeiCouponDown = true;
      } else {
        const dateCookieName = `jiangmei_coupon_down_${this.gameId}_mark`;
        const countCookieName = `jiangmei_coupon_down_${this.gameId}_count`;
        if (
          this.shouldShowPopupWithLimit(
            '2025-11-07T00:00:00+08:00',
            '2025-11-13T23:59:59+08:00',
            dateCookieName,
            countCookieName,
            7
          )
        ) {
          this.visibleJiangmeiCouponDown = true;
          this.markAsShownTodayWithCount(dateCookieName, countCookieName);
        }
      }
    }
    // 11.24 星谕：日本地区下架三方支付功能弹窗
    if (
      this.isInDisplayPeriod(
        '2025-11-24T11:00:00+09:00',
        '2025-12-31T23:59:59+09:00'
      ) &&
      this.$store?._actions?.[CHECK_IP_LOCATION] &&
      this.gameShowJpPayDown
    ) {
      this.$store.dispatch(CHECK_IP_LOCATION).then(res => {
        if (res?.ISO_TWO_CODE === 'JP' || this.lang === 'ja-JP') {
          // 根据不同页面类型确定支付版本
          const payVersionMap = {
            isOfficialTopupNew: 'v35',
            isOfficialTopup: 'v3',
            isOfficialWebStore: 'v2',
            isOfficialStore: 'v1'
          };

          const matchedKey = Object.keys(payVersionMap).find(
            key => window[key]
          );
          const payVersion = matchedKey ? payVersionMap[matchedKey] : 'v0';

          const dateCookieName = `jp_pay_down_notice_shown_${this.gameId}_${payVersion}_mark`;
          const countCookieName = `jp_pay_down_notice_shown_${this.gameId}_${payVersion}_count`;

          // 弹窗自动弹出到2025年12月31日
          if (
            this.shouldShowPopupWithLimit(
              '2025-11-24T11:00:00+09:00',
              '2025-12-31T23:59:59+09:00',
              dateCookieName,
              countCookieName,
              100000
            )
          ) {
            this.visibleJpPayDown = true;
            this.markAsShownTodayWithCount(dateCookieName, countCookieName);
          }
        }
      });
    }
  }
};
